const model = {
  id: null,
  name: null,
  ids: {},
  children: []
};
const editor = {};

const state = {
  view: "model-list",
  mode: null,
  overlay: false,
  loadingLayers: [],
  calcMode: "one",
  calcData: null,
  timeData: null,
  loadingCalc: null,
  activeCalc: null,
  diffCalc: null,
  activeCalcType: null,
  activeTimeValue: null,
  activeField: null,
  // max settings
  fieldMax: 0,
  localMax: 0,
  manualMax: 0,
  maxValue: 0,
  maxType: "field",
  diagramWidth: 300,
  // label settings
  showLabels: true,
  // timemachine settings
  timemachinePlaying: false,
  model,
  editor
};

const mutations = {
  SET_SM_MODEL(state, { id, name, ids, children }) {
    state.model.id = id;
    state.model.name = name;
    state.model.ids = ids;
    state.model.children = children;
  },
  CLEAR_SM_MODEL(state) {
    state.model = {
      ...model
    };
  },
  SET_SM_STATE_PROP(state, { name, value }) {
    state[name] = value;
  },
  ADD_SM_LOADING_LAYER(state, id) {
    if (state.loadingLayers.indexOf(id) === -1) state.loadingLayers.push(id);
  },
  REMOVE_SM_LOADING_LAYER(state, id) {
    state.loadingLayers.splice(state.loadingLayers.indexOf(id), 1);
  },
  CHANGE_SM_CALC_PROP(state, { field, value }) {
    state[field] = value;
  }
};

export default {
  state,
  mutations
};
